import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// --- IMPORTS ---
import LandingPage from './components/LandingPage';
import SavoriaDemo from './components/SavoriaDemo';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PublicMenu from './components/PublicMenu';
import AboutUs from './components/AboutUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Pricing from './components/Pricing';
import Features from './components/Features';
import Analytics from './components/Analytics';
import MasterAnalytics from './components/MasterAnalytics';
import RefundPolicy from './components/RefundPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/features" element={<Features />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/demo" element={<SavoriaDemo />} />

        <Route path="/menu/:restaurantId" element={<PublicMenu />} />

        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/master/analytics" element={<MasterAnalytics />} />
        <Route path="/refund" element={<RefundPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;